import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    post: null
  },
  getters: {
    getPost: (state) => state.post
  },
  actions: {
    loadPost ({ commit }, postId) {
      const url = `/annonce/${postId}`
      return HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          commit('setPost', response.data)
        }).catch(error => {
          console.log({ type: 'error', message: error })
        })
    }
  },
  mutations: {
    setPost (state, post) {
      state.post = post
    }
  }
}
